import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  List,
  Modal,
  Row,
  Spin,
  Tag,
} from "antd";
import { useState } from "react";
import { NewMemberTag } from "../../lib/discordTypes";

import { useGuildTagsContext } from "./DiscordTagsContext";

export default function EditTags() {
  const {
    guildTags,
    loading,
    selectedTag,
    isEditTagModalVisible,
    isDeleteTagModalVisible,
    setSelectedTag,
    setIsEditTagModalVisible,
    setIsDeleteTagModalVisible,
    updateTag,
    deleteTag,
    addTag,
    isAddTagModalVisible,
    setIsAddTagModalVisible,
  } = useGuildTagsContext();
  const [newTag, setNewTag] = useState<NewMemberTag>({
    name: "",
    description: "",
  });

  return (
    <>
      <Card
        style={{ marginBottom: 40 }}
        title={
          <div className="flex justify-between mt-2">
            <span>Edit Tags</span>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                window.analytics.track(
                  "Clicked add tag button in edit tags card",
                  {
                    platform: "discord",
                  }
                );
                setIsAddTagModalVisible && setIsAddTagModalVisible(true);
              }}
            >
              Add
            </Button>
          </div>
        }
        bordered={false}
        extra={[]}
      >
        <Spin spinning={loading}>
          <List
            size="large"
            className="skills-options"
            dataSource={guildTags || undefined}
            renderItem={(item) => (
              <List.Item
                // size="small"
                actions={[
                  <Button
                    type="primary"
                    className="-mt-4"
                    icon={<EditOutlined />}
                    size="small"
                    key={item.id}
                    onClick={() => {
                      if (setSelectedTag && setIsEditTagModalVisible) {
                        setSelectedTag(item);
                        setIsEditTagModalVisible(true);
                      }
                    }}
                  />,
                  <Button
                    type="dashed"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    key={item.id}
                    onClick={() => {
                      if (setSelectedTag && setIsDeleteTagModalVisible) {
                        setSelectedTag(item);
                        setIsDeleteTagModalVisible(true);
                      }
                    }}
                  />,
                ]}
              >
                <List.Item.Meta
                  title={
                    <Tag color={item.color} style={{ margin: 0 }} key={item.id}>
                      {item.name}
                    </Tag>
                  }
                  description={item.description ? item.description : null}
                />
              </List.Item>
            )}
          />
        </Spin>
      </Card>
      <Modal
        title={`Delete tag: ${selectedTag && selectedTag.name}`}
        onCancel={() =>
          setIsDeleteTagModalVisible && setIsDeleteTagModalVisible(false)
        }
        visible={isDeleteTagModalVisible}
        footer={null}
      >
        {selectedTag && selectedTag.name ? (
          <div className="space-y-4">
            <div>
              <p>{`Delete the ${selectedTag.name} tag?`}</p>
              <p>{`This will remove the ${selectedTag.name} tag from all members.`}</p>
            </div>
            <div className="flex flex-row justify-evenly">
              <Button
                type="dashed"
                onClick={() => deleteTag()}
                danger
                icon={<DeleteOutlined />}
              >
                Delete
              </Button>
            </div>
          </div>
        ) : (
          "Loading"
        )}
      </Modal>
      <Modal
        title={`Edit tag: ${selectedTag && selectedTag.name}`}
        onCancel={() =>
          setIsEditTagModalVisible && setIsEditTagModalVisible(false)
        }
        visible={isEditTagModalVisible}
        footer={null}
      >
        {selectedTag && selectedTag.name ? (
          <div className="space-y-4">
            <div>
              Name:{" "}
              <Input
                value={selectedTag.name}
                onChange={(e) =>
                  setSelectedTag &&
                  setSelectedTag({ ...selectedTag, name: e.target.value })
                }
              />
            </div>
            <div>
              Description:{" "}
              <Input
                type="textarea"
                value={selectedTag.description || undefined}
                onChange={(e) => {
                  if (setSelectedTag) {
                    setSelectedTag({
                      ...selectedTag,
                      description: e.target.value,
                    });
                  }
                }}
              />
            </div>
            <div className="flex flex-row justify-evenly">
              <Button
                type="dashed"
                onClick={() => deleteTag()}
                danger
                icon={<DeleteOutlined />}
              >
                Delete
              </Button>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => updateTag()}
                  icon={<SaveOutlined />}
                >
                  Update
                </Button>
              </Form.Item>
            </div>
          </div>
        ) : (
          "Loading"
        )}
      </Modal>
      <Modal
        title={`Add tag`}
        onCancel={() =>
          setIsAddTagModalVisible && setIsAddTagModalVisible(false)
        }
        visible={isAddTagModalVisible}
        footer={null}
      >
        <Form
          layout="vertical"
          onFinish={() => {
            setIsAddTagModalVisible && setIsAddTagModalVisible(false);
            if (addTag) addTag(newTag);
            else console.error("addTag clicked before addTag was defined");
          }}
        >
          <div className="space-y-4">
            <Form.Item label="Name">
              <Input
                value={newTag.name}
                onChange={(e) =>
                  setNewTag((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
              />
            </Form.Item>
            <div>
              Description:{" "}
              <Input
                value={newTag.description || undefined}
                onChange={(e) => {
                  setNewTag((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="flex flex-row justify-evenly">
              <Form.Item>
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  htmlType="submit"
                >
                  Save
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
}
